export const nextFlocknoteIsNew = process.env.NODE_ENV !== "test";
